import api from '@/api'

export function fetchResources () {
  return api.get('/resources/')
}

export function fetchResourceByUrl (url) {
  return api.get(url)
}
